import L from 'leaflet'
import 'leaflet-draw'

L.drawLocal.draw.handlers.polygon.tooltip.start = 'Clic para dibujar área a Quemar.'
L.drawLocal.draw.handlers.polygon.tooltip.cont = 'Clic para continuar dibujando.'
L.drawLocal.draw.handlers.polygon.tooltip.end = 'Clic en primer punto para cerrar área.'
L.drawLocal.edit.toolbar.actions.clearAll.text = 'Borrar todo'
L.drawLocal.edit.toolbar.actions.cancel.text = 'Cancelar'
L.drawLocal.edit.toolbar.actions.save.text = 'Confirmar'
L.drawLocal.draw.toolbar.finish.text = 'Finalizar'
L.drawLocal.draw.toolbar.actions.text = 'Cancelar'
L.drawLocal.draw.toolbar.undo.text = 'Deshacer'
L.drawLocal.edit.handlers.remove.tooltip.text = 'Clic en un área para eliminarlo.'
L.drawLocal.edit.handlers.edit.tooltip.text = 'Arrastre los vertices para editar un área.'
L.drawLocal.edit.handlers.edit.tooltip.subtext = 'Clic en Cancelar para deshacer cambios.'
L.drawLocal.draw.toolbar.buttons.polygon = 'Dibujar un área.'
L.drawLocal.edit.toolbar.buttons.edit = 'Editar áreas.'
L.drawLocal.edit.toolbar.buttons.editDisabled = 'No hay área para editar.'
L.drawLocal.edit.toolbar.buttons.remove = 'Eliminar áreas.'
L.drawLocal.edit.toolbar.buttons.removeDisabled = 'No hay área para eliminar.'
